import {
	axiosErrorHandler,
	deletes,
	get,
	post,
	put,
} from 'models/shared/helpers/axiosInstance';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import {
	GeotetTileResponseDto,
	Geotile,
	GeotileFilterDto,
	GeotileHistoryLocationDto,
	GetHistoryResponseDto,
	UpdateGeotileDto,
} from '../interfaces/geotile.interface';

const baseTilePath = '/v1/tile/devices';

export const fetchGeotiles = async (dto: GeotileFilterDto) => {
	try {
		const res = await get<PaginatedDocuments<Geotile>>(
			buildPathWithQueryParams('/v1/tile', dto),
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchGeotile = async (id: string) => {
	try {
		const url = `${baseTilePath}/${id}`;
		const res = await get<Geotile>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchGeotilesLocations = async () => {
	try {
		const res = await get<GeotetTileResponseDto[]>(baseTilePath);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchGeotileHistory = async (id: string, days = 90) => {
	try {
		const url = `${baseTilePath}/${id}/history?days=${days}`;
		const res = await get<GetHistoryResponseDto>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateTile = async (values: UpdateGeotileDto, id: string) => {
	try {
		const res = await put<Geotile>(`${baseTilePath}/${id}`, values);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const syncGeotiles = async () => {
	try {
		const res = await post<{ created: number }>('/v1/tile/sync');
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
